module.exports = __webpack_public_path__ + "static/media/goPaperless.d182e284.jpeg";